import ApiConstant from "../../constants/api.constants";
import api from "../api";
import { OptimizeRouteRequestDto } from "../../components/GeoMap/routeTypes";

const getOrders = async (filter: string) => {
    try {
        const Orders: any = await api
            .get(ApiConstant.getAllOrder + filter)
            .then((result: any) => {
                if (result)
                    return result.data;
                else
                    return null;
            })
            .catch(function (error: any) {
                console.error('error reading get orders data.', error);
            });
        const response = Orders != null ? Orders : null;
        return response;
    }
    catch (e) {
        console.log('error in getOrders');
        return [];
    }
}

const getPOS = async () => {
    try {
        const Orders: any = await api
            .get(ApiConstant.getAllPOS)
            .then((result: any) => {
                if (result)
                    return result.data;
                else
                    return null;
            })
            .catch(function (error: any) {
                console.error('error reading get POS data.', error);
            });
        const response = Orders != null ? Orders : null;
        return response;
    }
    catch (e) {
        console.log('error in getAllPOS');
        return [];
    }
}

const getOrderUsers = async (filter: string) => {
    try {
        const Users: any = await api
            .get(ApiConstant.getOrderUserList + filter)
            .then((result: any) => {
                if (result)
                    return result.data;
                else
                    return null;
            })
            .catch(function (error: any) {
                console.error('error reading get order user list data.', error);
            });
        const response = Users != null ? Users : null;
        return response;
    }
    catch (e) {
        console.log('error in getUserMobileData');
        return [];
    }
}

const orderOrderdDetails = async (filters: {
    startDate?: Date;
    endDate?: Date;
    orderID?: number;
    invoiceNo?: number;
    userID?: number;
    orderType?: number;
    pageNumber?: number;
    pageSize?: number;
}): Promise<any> => {
    try {
        const formatDate = (date?: Date) => {
            if (!date) return null;
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };
        const requestBody = {
            startDate: formatDate(filters.startDate),
            endDate: formatDate(filters.endDate),
            orderIDs: filters.orderID ?? null,
            invoiceNo: filters.invoiceNo ?? null,
            userIDs: filters.userID ?? null,
            orderType: filters.orderType ?? null,
            pageNumber: filters.pageNumber ?? null,
            pageSize: filters.pageSize ?? null
        };
        const response = await api.post(ApiConstant.orderDetails, requestBody)
            .then((result: any) => {
                if (result) {
                    return result.data;
                }
                return null;
            })
            .catch((error: any) => {
                console.error('Error searching orders:', error);
                throw error;
            });

        return response || [];
    }
    catch (e) {
        console.error('Error in searchOrders:', e);
        return [];
    }
};

const GetOrderByOrderId = async (OrderId: number) => {
    const url = `${ApiConstant.getAllOrderByOrderId}?orderId=${encodeURIComponent(OrderId)}`;
    try {
        const response = await api.get(url, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        if (response.data) {
            if (Array.isArray(response.data) && response.data.length > 0) {
                return response.data[0];
            } else {
                console.warn("Empty or invalid response data:", response.data);
                return null;
            }
        } else {
            console.warn("No data returned in the response:", response);
            return null;
        }
    } catch (error) {
        console.error("Error fetching order details:", error);
        return null;
    }
}

const getorderExport = async (filter: { orderIds: number[] }) => {
    try {
        const response = await api.post(ApiConstant.getorderExport, filter);
        return response.data;
    } catch (error) {
        console.error('Error fetching order export data:', error);
        return [];
    }
};

const getOrderExportDetails = async (filter: {
    orderID?: number,
    invoiceNo?: number,
    userID?: number,
    orderType?: number;
    startDate?: Date;
    endDate?: Date;
}) => {
    try {
        const formatDate = (date?: Date) => {
            if (!date) return null;
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };
        const requestBody = {
            orderID: filter.orderID ?? null,
            invoiceNo: filter.invoiceNo ?? null,
            userID: filter.userID ?? null,
            orderType: filter.orderType ?? null,
            startDate: formatDate(filter.startDate) ?? null,
            endDate: formatDate(filter.endDate) ?? null
        };
        const response = await api.post(ApiConstant.getOrderExportDetails, requestBody);
        return response.data;
    } catch (error) {
        console.error('Error fetching order export data:', error);
        return [];
    }
};

const getOrderInvoiceExportdetails = async (filter: {
    orderID?: number,
    invoiceNo?: number,
    userID?: number,
    orderType?: number;
    startDate?: Date;
    endDate?: Date;
}) => {
    try {
        const formatDate = (date?: Date) => {
            if (!date) return null;
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };
        const requestBody = {
            orderID: filter.orderID ?? null,
            invoiceNo: filter.invoiceNo ?? null,
            userID: filter.userID ?? null,
            orderType: filter.orderType ?? null,
            startDate: formatDate(filter.startDate) ?? null,
            endDate: formatDate(filter.endDate) ?? null
        };
        const response = await api.post(ApiConstant.getOrderInvoiceExportdetails, requestBody);
        return response.data;
    } catch (error) {
        console.error('Error fetching order export data:', error);
        return [];
    }
};

const getInvoices = async (filter: { orderIds: number[] }) => {
    try {
        const response = await api.post(ApiConstant.getInvoices, filter);
        return response.data;
    } catch (error) {
        console.error('Error fetching order export data:', error);
        return [];
    }
};

const getInvoicedetails = async (filter: { orderIds: number[] }) => {
    try {
        const response = await api.post(ApiConstant.getInvoicedetails, filter);
        return response.data;
    } catch (error) {
        console.error('Error fetching order export data:', error);
        return [];
    }
};

const getuserdetails = async (filter: string) => {
    try {
        const Users: any = await api
            .get(ApiConstant.NewGetOrderUserList + filter)
            .then((result: any) => {
                if (result)
                    return result.data;
                else
                    return null;
            })
            .catch(function (error: any) {
                console.error('error reading get order user list data.', error);
            });
        const response = Users != null ? Users : null;
        return response;
    }
    catch (e) {
        console.log('error in getUserMobileData');
        return [];
    }
}

const getUserDetailComplaint = async (userId: number) => {
    try {
        const Users: any = await api
            .get(ApiConstant.getUserDetailsComplaint + userId)
            .then((result: any) => {
                if (result)
                    return result.data;
                else
                    return null;
            })
            .catch(function (error: any) {
                console.error('error reading get order user list data.', error);
            });
        const response = Users != null ? Users : null;
        return response;
    }
    catch (e) {
        console.log('error in getUserMobileData');
        return [];
    }
}

const GetPackingOrderByOrderId = async (OrderId: number) => {
    const url = `${ApiConstant.getPackingOrderByOrderId}?orderId=${encodeURIComponent(OrderId)}`;
    try {
        const response = await api.get(url, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        if (response.data) {
            if (Array.isArray(response.data) && response.data.length > 0) {
                return response.data[0];
            } else {
                console.warn("Empty or invalid response data:", response.data);
                return null;
            }
        } else {
            console.warn("No data returned in the response:", response);
            return null;
        }
    } catch (error) {
        console.error("Error fetching order details:", error);
        return null;
    }
}

const saveOrderPacking = async (params: {
    orderID: number;
    packingNo: number | null;
}) => {
    try {
        const requestBody = {
            OrderID: params.orderID,
            PackingNo: params.packingNo
        };
        const response = await api.post(ApiConstant.saveOrderPacking, requestBody, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error saving packing information:', error);
        return null;
    }
};

const getOrderCities = async (params: {
    startDate: string;
    endDate: string;
}) => {
    try {
        const response = await api
            .post(ApiConstant.getOrderCities, params)
            .then((result: any) => {
                if (result) return result.data;
                return null;
            })
            .catch((error: any) => {
                console.error('Error reading city data.', error);
                return null;
            });

        return response != null ? response : { cities: [] };
    } catch (e) {
        console.log('Error in getOrderCities:', e);
        return { cities: [] };
    }
};

const binOrderDetails = async (params: {
    packingStatus: string;
    startDate: string;
    endDate: string;
    SubdistrictIds: number[];
    pageNumber: number;
    pageSize: number;
}) => {
    try {
        const requestBody = {
            StartDate: params.startDate,
            EndDate: params.endDate,
            PageNumber: params.pageNumber,
            PageSize: params.pageSize,
            PackedStatus: params.packingStatus,
            SubdistrictIds: params.SubdistrictIds,
        };
        const response = await api.post(ApiConstant.binOrderDetails, requestBody, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching order details:', error);
        return null;
    }
};

const orderInvoicedDetails = async (filters: {
    startDate?: Date;
    endDate?: Date;
    orderID?: number;
    invoiceNo?: number;
    userID?: number;
    orderType?: number;
    pageNumber?: number;
    pageSize?: number;
}): Promise<any> => {
    try {
        const formatDate = (date?: Date) => {
            if (!date) return null;
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        const requestBody = {
            startDate: formatDate(filters.startDate),
            endDate: formatDate(filters.endDate),
            orderIDs: filters.orderID ?? null,
            invoiceNos: filters.invoiceNo ?? null,
            userIDs: filters.userID ?? null,
            orderType: filters.orderType ?? null,
            pageNumber: filters.pageNumber ?? null,
            pageSize: filters.pageSize ?? null
        };
        const response = await api.post(ApiConstant.invoiceDetails, requestBody)
            .then((result: any) => {
                if (result) {
                    return result.data;
                }
                return null;
            })
            .catch((error: any) => {
                console.error('Error searching orders:', error);
                throw error;
            });

        return response || [];
    }
    catch (e) {
        console.error('Error in searchOrders:', e);
        return [];
    }
};

const importDriverList = async (drivers: {
    orderID: number;
    primaryContactNumber: string;
    sequenceNo: number;
    vehicleNo: string;
}[]) => {
    try {
        const requestBody = {
            deliveries: drivers.map(driver => ({
                orderID: driver.orderID,
                primaryContactNumber: driver.primaryContactNumber,
                sequenceNo: driver.sequenceNo,
                vehicleNo: driver.vehicleNo
            }))
        };
        const response = await api.post(ApiConstant.importDriverList, requestBody, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error importing driver list:', error);
        throw error;
    }
};


const importDriverList1 = async (drivers: {
    orderID: number;
    primaryContactNumber: string;
    sequenceNo: number;
    vehicleNo: string;
}[]) => {
    try {
        const requestBody = {
            deliveries: drivers.map(driver => ({
                orderID: driver.orderID,
                primaryContactNumber: driver.primaryContactNumber,
                sequenceNo: driver.sequenceNo,
                vehicleNo: driver.vehicleNo
            }))
        };
        const response = await api.post(ApiConstant.importDriverList1, requestBody, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error importing driver list:', error);
        throw error;
    }
};

const sendWhatsAppTemplateMessage = async (
    id: number,
    messageType: string
) => {
    try {
        const payload = { orderId: id, messageType };
        const response = await api.post("/api/whatsapp/send", payload);
        return response.data;
    } catch (error: any) {
        console.error(`Error sending WhatsApp message (${messageType}) for ID ${id}`, error);
        throw error;
    }
};


const getDeliveredOrders = async () => {
    try {
        const Orders: any = await api
            .get(ApiConstant.getDeliveredOrders)
            .then((result: any) => {
                if (result)
                    return result.data;
                else
                    return null;
            })
            .catch(function (error: any) {
                console.error('error reading get POS data.', error);
            });
        const response = Orders != null ? Orders : null;
        return response;
    }
    catch (e) {
        console.log('error in getAllPOS');
        return [];
    }
}

const getDeliveryOrders = async () => {
    try {
        const Orders: any = await api
            .get(ApiConstant.getDeliveryOrders)
            .then((result: any) => {
                if (result)
                    return result.data;
                else
                    return null;
            })
            .catch(function (error: any) {
                console.error('error reading get POS data.', error);
            });
        const response = Orders != null ? Orders : null;
        return response;
    }
    catch (e) {
        console.log('error in getAllPOS');
        return [];
    }
}

const getCashCollectionReport = async (filter: any) => {
    try {
        const formatDate = (date?: Date) => {
            if (!date) return null;
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };
        filter.startDate = formatDate(filter.startDate);
        filter.endDate = formatDate(filter.endDate);
        const response = await api.post(ApiConstant.cashCollectionReport, filter)
            .then((result: any) => {
                if (result) {
                    return result.data;
                }
                return null;
            })
            .catch((error: any) => {
                console.error('Error searching orders:', error);
                throw error;
            });

        return response || [];
    }
    catch (e) {
        console.error('Error in searchOrders:', e);
        return [];
    }
}

const getPaymentLinkList = async (filter: any) => {
    try {
        const formatDate = (date?: Date) => {
            if (!date) return null;
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };
        filter.dateFilter.startDate = formatDate(filter.dateFilter.startDate);
        filter.dateFilter.endDate = formatDate(filter.dateFilter.endDate)
        var data = {
            "startDate": filter.dateFilter.startDate,
            "endDate": filter.dateFilter.endDate,
            "userId": filter.dateFilter.userId
        }
        const response = await api.post(ApiConstant.paymentLink, data)
            .then((result: any) => {
                if (result) {
                    return result.data;
                }
                return null;
            })
            .catch((error: any) => {
                console.error('Error searching orders:', error);
                throw error;
            });

        return response || [];
    }
    catch (e) {
        console.error('Error in searchOrders:', e);
        return [];
    }
}

const updateActualpayment = async (filter: any) => {
    try {
        const response = await api.post(ApiConstant.updateActualpayment, filter)
            .then((result: any) => {
                if (result) {
                    return result.data;
                }
                return null;
            })
            .catch((error: any) => {
                console.error('Error searching orders:', error);
                throw error;
            });

        return response || [];
    }
    catch (e) {
        console.error('Error in searchOrders:', e);
        return [];
    }
}

const cashandOnlineList = async (filter: any) => {
    try {
        const formatDate = (date?: Date) => {
            if (!date) return null;
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };
        filter.dateFilter.startDate = formatDate(filter.dateFilter.startDate);
        filter.dateFilter.endDate = formatDate(filter.dateFilter.endDate)
        var data = {
            "startDate": filter.dateFilter.startDate,
            "endDate": filter.dateFilter.endDate,
            "userId": filter.dateFilter.userId,
            "collectionType": filter.dateFilter.collectionType
        }
        const response = await api.post(ApiConstant.cashandonline, data)
            .then((result: any) => {
                if (result) {
                    return result.data;
                }
                return null;
            })
            .catch((error: any) => {
                console.error('Error searching orders:', error);
                throw error;
            });

        return response || [];
    }
    catch (e) {
        console.error('Error in searchOrders:', e);
        return [];
    }
}

export const getOrderAddress = async (orderId: number) => {
    try {
        const result: any = await api
            .get(ApiConstant.getOrderAddressInfo + orderId)
            .then((response: any) => {
                if (response) return response.data;
                else return null;
            })
            .catch((error: any) => {
                console.error("Error fetching order address info.", error);
                return null;
            });

        return result != null ? result : null;
    } catch (e) {
        console.log("Unexpected error in getOrderAddressInfo", e);
        return null;
    }
};

const getDriversList = async (filter: string) => {
    try {
        const Users: any = await api
            .get(ApiConstant.getDriversList + filter)
            .then((result: any) => {
                if (result)
                    return result.data;
                else
                    return null;
            })
            .catch(function (error: any) {
                console.error('error reading get order user list data.', error);
            });
        const response = Users != null ? Users : null;
        return response;
    }
    catch (e) {
        console.log('error in getUserMobileData');
        return [];
    }
}

const getAdminDeliveryDetails = async (driverId: number) => {
    const url = `${ApiConstant.getAdminDeliveryDetails}?driverId=${encodeURIComponent(driverId)}`;
    try {
        const response = await api.get(url, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        if (response.data) {
            return response.data;
        } else {
            console.warn("No data returned in the response:", response);
            return [];
        }
    } catch (error) {
        console.error("Error fetching admin delivery details:", error);
        return [];
    }
}

const getAdminDeliveredDetails = async (driverId: number) => {
    const url = `${ApiConstant.getAdminDeliveredDetails}?driverId=${encodeURIComponent(driverId)}`;
    try {
        const response = await api.get(url, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        if (response.data) {
            return response.data;
        } else {
            console.warn("No data returned in the response:", response);
            return [];
        }
    } catch (error) {
        console.error("Error fetching admin delivered details:", error);
        return [];
    }
}

const getChallanProducts = async (): Promise<any[]> => {
    try {
        const result = await api.get(ApiConstant.getChallanProducts);
        if (result && result.data) {
            return result.data;
        } else {
            return [];
        }
    } catch (error) {
        console.error('Error while fetching product summary:', error);
        return [];
    }
}

const createChallan = async () => {
    try {
        const result = await api.post(ApiConstant.createChallan);
        if (result && result.data) {
            return result.data;
        } else {
            return [];
        }
    } catch (error) {
        console.error('Error while fetching product summary:', error);
        return [];
    }
}

const GenerateInvoiceDetails = async (filters: {
    startDate?: Date;
    endDate?: Date;
    orderId?: number;
    userId?: number;
    pageNumber?: number;
    pageSize?: number;
}): Promise<any> => {
    try {
        const formatDate = (date?: Date) => {
            if (!date) return null;
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        const requestBody = {
            startDate: formatDate(filters.startDate),
            endDate: formatDate(filters.endDate),
            orderId: filters.orderId ?? null,
            userId: filters.userId ?? null,
            pageNumber: filters.pageNumber ?? null,
            pageSize: filters.pageSize ?? null
        };
        const response = await api.post(ApiConstant.GenerateInvoiceDetails, requestBody)
            .then((result: any) => {
                if (result) {
                    return result.data;
                }
                return null;
            })
            .catch((error: any) => {
                console.error('Error searching orders:', error);
                throw error;
            });

        return response || [];
    }
    catch (e) {
        console.error('Error in searchOrders:', e);
        return [];
    }
};

const GetOrderByOrderIdForInvoice = async (OrderId: number) => {
    const url = `${ApiConstant.GetOrderByOrderIdForInvoice}?orderId=${encodeURIComponent(OrderId)}`;
    try {
        const response = await api.get(url, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        if (response.data) {
            if (Array.isArray(response.data) && response.data.length > 0) {
                return response.data[0];
            } else {
                console.warn("Empty or invalid response data:", response.data);
                return null;
            }
        } else {
            console.warn("No data returned in the response:", response);
            return null;
        }
    } catch (error) {
        console.error("Error fetching order details:", error);
        return null;
    }
}

const GetPullPaymentStatusLogs = async () => {
    try {
        const result = await api.post(ApiConstant.pullPaymentStatusLogs);
        if (result && result.data) {
            return result.data;
        } else {
            return [];
        }
    } catch (error) {
        console.error('Error while fetching PullPaymentStatusLogs OrderIds:', error);
        return [];
    }
}



// const getOpenOrdersForMap = async (

//   routeCodeId?: number,
//   fromDate?: string,
//   toDate?: string
// ): Promise<any[]> => {
//   let query = [];

//   if (routeCodeId !== undefined) {
//     query.push(`routeCodeId=${encodeURIComponent(routeCodeId)}`);
//   }
//   if (fromDate) {
//     query.push(`fromDate=${encodeURIComponent(fromDate)}`);
//   }
//   if (toDate) {
//     query.push(`toDate=${encodeURIComponent(toDate)}`);
//   }

//   const queryString = query.length > 0 ? `?${query.join("&")}` : "";
//   const url = `${ApiConstant.getOpenOrdersForMap}${queryString}`;

//   try {
//     const response = await api.get(url, {
//       headers: {
//         "Content-Type": "application/json",
//       },
//     });

//     if (response.data) {
//       return response.data;
//     } else {
//       console.warn("No data returned in the response:", response);
//       return [];
//     }
//   } catch (error) {
//     console.error("Error fetching open orders for map:", error);
//     return [];
//   }
// };

const getOpenOrdersForMap = async (
    routeCodeIds?: number[],
    fromDate?: string,
    toDate?: string
): Promise<any> => {
    let query: string[] = [];

    // append all selected route codes
    if (routeCodeIds && routeCodeIds.length > 0) {
        routeCodeIds.forEach(id => {
            query.push(`routeCodeIds=${encodeURIComponent(id)}`);
        });
    }

    if (fromDate) {
        query.push(`fromDate=${encodeURIComponent(fromDate)}`);
    }
    if (toDate) {
        query.push(`toDate=${encodeURIComponent(toDate)}`);
    }

    const queryString = query.length > 0 ? `?${query.join("&")}` : "";
    const url = `${ApiConstant.getOpenOrdersForMap}${queryString}`;

    try {
        const response = await api.get(url, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data || {};
    } catch (error) {
        console.error("Error fetching open orders for map:", error);
        return {};
    }
};

const orderoptimized = async (payload: OptimizeRouteRequestDto) => {
    try {
        // console.log("Fetching optimized route with payload:", payload);
        const res = await api.post(ApiConstant.getOptimizedRoute, payload);
        return res?.data ?? [];
    } catch (err) {
        console.error("Error while fetching optimized route:", err);
        return [];
    }
};

const getCustomerDeliveryReport = async () => {
    try {
        const result = await api.get(ApiConstant.getCustomerDeliveryReport);
        if (result) {
            return result.data;
        } else {
            return [];
        }
    } catch (error) {
        console.error('Error while fetching PullPaymentStatusLogs OrderIds:', error);
        return [];
    }
}

const getVesselDetails = async (orderIdstring?: string[]) => {
    try {
        const orderIds = orderIdstring?.join(",");

        const result = await api.post(ApiConstant.getVesselDetails, {
            OrderIDs: orderIds  // matches DTO property
        });

        if (result) {
            return result.data.vesselRequirements;
        } else {
            return [];
        }
    } catch (error) {
        console.error("Error while fetching vessel requirements:", error);
        return [];
    }
};

const getPaymentOrderStatus = async (OrderId: any) => {
    try {
        const result = await api.post(ApiConstant.GetPaymentOrderStatus + OrderId);
        if (result) {
            return result.data;
        } else {
            return [];
        }
    } catch (error) {
        console.error('Error while fetching PullPaymentStatusLogs OrderIds:', error);
        return [];
    }
}

const searchDelayStatus = async (filter: { keyword: string }) => {
    try {
        const response = await api.post(ApiConstant.searchDelayStatus, filter);
        return response.data;
    } catch (error) {
        console.error("Error searching subdistricts:", error);
        return [];
    }
};

const saveDeliveryDelay = async (params: {
    orderID: number | null;
    statusId: number;
    delayDescription: string | null;
}) => {
    try {
        const requestBody = {
            orderID: params.orderID,
            statusId: params.statusId,
            description: params.delayDescription
        };
        const response = await api.post(ApiConstant.saveDeliveryDelay, requestBody, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error order delay information:', error);
        return null;
    }
};

const getDelayedOrders = async () => {
    try {
        const Orders: any = await api
            .get(ApiConstant.getDelayedOrders)
            .then((result: any) => {
                if (result)
                    return result.data;
                else
                    return null;
            })
            .catch(function (error: any) {
                console.error('error reading get POS data.', error);
            });
        const response = Orders != null ? Orders : null;
        return response;
    }
    catch (e) {
        console.log('error in getAllPOS');
        return [];
    }
}

// export const getDriverOrdersDailySummary = async () => {
//   try {
//     const DailySummary: any = await api
//       .get(ApiConstant.getDriverOrdersDailySummary) // ← no params
//       .then((result: any) => (result ? result.data : null))
//       .catch((error: any) => {
//         console.error("error reading daily summary.", error);
//       });

//     return DailySummary ?? null;
//   } catch (e) {
//     console.log("error in getDriverOrdersDailySummary");
//     return [];
//   }
// };
// services/orders/orderservice.ts
export const getDriverOrdersDailySummary = async (forDate?: string) => {
    try {
        const DailySummary: any = await api
            .get(ApiConstant.getDriverOrdersDailySummary, {
                params: { forDate }, // ✅ pass as query param
            })
            .then((result: any) => (result ? result.data : null))
            .catch((error: any) => {
                console.error("error reading daily summary.", error);
            });

        return DailySummary ?? null;
    } catch (e) {
        console.log("error in getDriverOrdersDailySummary");
        return [];
    }
};


const getAdminDelayedDetails = async (driverId: number) => {
    const url = `${ApiConstant.getAdminDelayedDetails}?driverId=${encodeURIComponent(driverId)}`;
    try {
        const response = await api.get(url, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        if (response.data) {
            return response.data;
        } else {
            console.warn("No data returned in the response:", response);
            return [];
        }
    } catch (error) {
        console.error("Error fetching admin delivered details:", error);
        return [];
    }
}

const getDeliveryAnalysis = async (params: {
    startDate: Date;
    endDate: Date;
    executiveId: number | null;
    deliveryDays?: number;
}) => {
    try {
        const formatDate = (date?: Date) => {
            if (!date) return null;
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };
        const requestBody = {
            startDate: formatDate(params.startDate),
            endDate: formatDate(params.endDate),
            executiveId: params.executiveId,
            deliveryDays: params.deliveryDays
        };
        const response = await api.post(ApiConstant.getDeliveryAnalysis, requestBody, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching delivery analysis:", error);
        return null;
    }
};

const getAssignedOrdersDetails = async (params: {
    startDate: Date;
    endDate: Date;
    executiveId: number | null;
}) => {
    try {
        const formatDate = (date?: Date) => {
            if (!date) return null;
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };
        const requestBody = {
            startDate: formatDate(params.startDate),
            endDate: formatDate(params.endDate),
            executiveId: params.executiveId,
        };

        const response = await api.post(ApiConstant.getAssignedOrdersDetails, requestBody, {
            headers: { "Content-Type": "application/json" },
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching assigned orders details:", error);
        return [];
    }
};

const getUndeliveredOrdersDetails = async (params: {
    startDate: Date;
    endDate: Date;
    executiveId: number | null;
}) => {
    try {
        const formatDate = (date?: Date) => {
            if (!date) return null;
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };
        const requestBody = {
            startDate: formatDate(params.startDate),
            endDate: formatDate(params.endDate),
            executiveId: params.executiveId,
        };

        const response = await api.post(ApiConstant.getUndeliveredOrdersDetails, requestBody, {
            headers: { "Content-Type": "application/json" },
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching assigned orders details:", error);
        return [];
    }
};

const getDeliveredOrdersDetails = async (params: {
    startDate: Date;
    endDate: Date;
    executiveId: number | null;
}) => {
    try {
        const formatDate = (date?: Date) => {
            if (!date) return null;
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };
        const requestBody = {
            startDate: formatDate(params.startDate),
            endDate: formatDate(params.endDate),
            executiveId: params.executiveId,
        };

        const response = await api.post(ApiConstant.getDeliveredOrdersDetails, requestBody, {
            headers: { "Content-Type": "application/json" },
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching assigned orders details:", error);
        return [];
    }
};
export interface OrderLocationDto {
    lat: number;
    lng: number;
    orderId?: string;
    customerName?: string;
    amount?: number;
    sequence: number;
    driverId?: number;
}
const getDriversDetails = async () => {
    try {
        const result = await api.get(ApiConstant.getDrivers);
        if (result) {
            return result.data;
        } else {
            return [];
        }
    } catch (error) {
        console.error('Error while fetching drivers details:', error);
        return [];
    }
}

const getPreChallanProducts = async (orderIds: (string | number)[]): Promise<any[]> => {
    try {

        const result = await api.post(ApiConstant.getPreChallanProducts, { orderIds });
        if (result && result.data) {
            return result.data;
        } else {
            return [];
        }
    } catch (error) {
        console.error("Error while fetching product summary:", error);
        return [];
    }
};

const getAssignedCancelledOrdersDetails = async (params: {
    startDate: Date;
    endDate: Date;
    executiveId: number | null;
}) => {
    try {
        const formatDate = (date?: Date) => {
            if (!date) return null;
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };
        const requestBody = {
            startDate: formatDate(params.startDate),
            endDate: formatDate(params.endDate),
            executiveId: params.executiveId,
        };

        const response = await api.post(ApiConstant.getAssignedCancelledOrdersDetails, requestBody, {
            headers: { "Content-Type": "application/json" },
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching assigned cancelled orders details:", error);
        return [];
    }
};

const searchSupplyType = async (filter: { keyword: string }) => {
    try {
        const response = await api.post(ApiConstant.getSupplyType, filter);
        return response.data;
    } catch (error) {
        console.error("Error searching Supply Type:", error);
        return [];
    }
};

const searchSubSupplyType = async (filter: { keyword: string }) => {
    try {
        const response = await api.post(ApiConstant.getSubSupplyType, filter);
        return response.data;
    } catch (error) {
        console.error("Error searching Sub Supply Type:", error);
        return [];
    }
};

const searchDocumentType = async (filter: { keyword: string }) => {
    try {
        const response = await api.post(ApiConstant.getDocumentType, filter);
        return response.data;
    } catch (error) {
        console.error("Error searching Document Type:", error);
        return [];
    }
};

const searchTransportationMode = async (filter: { keyword: string }) => {
    try {
        const response = await api.post(ApiConstant.getTransportationMode, filter);
        return response.data;
    } catch (error) {
        console.error("Error searching Transportation Mode:", error);
        return [];
    }
};

const searchConsignmentStatus = async (filter: { keyword: string }) => {
    try {
        const response = await api.post(ApiConstant.getConsignmentStatus, filter);
        return response.data;
    } catch (error) {
        console.error("Error searching Consignment Status:", error);
        return [];
    }
};

const searchModeOfGeneration = async (filter: { keyword: string }) => {
    try {
        const response = await api.post(ApiConstant.getModeOfGeneration, filter);
        return response.data;
    } catch (error) {
        console.error("Error searching Mode Of Generation:", error);
        return [];
    }
};

const searchEwayBillStatus = async (filter: { keyword: string }) => {
    try {
        const response = await api.post(ApiConstant.getEwayBillStatus, filter);
        return response.data;
    } catch (error) {
        console.error("Error searching Eway Bill Status:", error);
        return [];
    }
};

const searchCancellationReasonCodes = async (filter: { keyword: string }) => {
    try {
        const response = await api.post(ApiConstant.getCancellationReasonCodes, filter);
        return response.data;
    } catch (error) {
        console.error("Error searching Cancellation Reason Codes:", error);
        return [];
    }
};

const searchVehicleType = async (filter: { keyword: string }) => {
    try {
        const response = await api.post(ApiConstant.getVehicleType, filter);
        return response.data;
    } catch (error) {
        console.error("Error searching Vehicle Type:", error);
        return [];
    }
};

const searchReasonForExtensionValidity = async (filter: { keyword: string }) => {
    try {
        const response = await api.post(ApiConstant.getReasonForExtensionValidity, filter);
        return response.data;
    } catch (error) {
        console.error("Error searching Reason For Extension Validity:", error);
        return [];
    }
};

const searchTransactionTypes = async (filter: { keyword: string }) => {
    try {
        const response = await api.post(ApiConstant.getTransactionTypes, filter);
        return response.data;
    } catch (error) {
        console.error("Error searching Transaction Types:", error);
        return [];
    }
};

const generateEwayBill = async (payload: any) => {
    try {
        const response = await api.post(ApiConstant.generateEwayBill, payload, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error generating E-way bill:", error);
        throw error;
    }
};

export const getOrderDeliveryStatus = async (filter: {
    orderID?: number | null;
    primaryContactNbr?: string | null;
}) => {
    try {
        const response = await api.post(ApiConstant.GetOrderdeliverySummary, filter);
        return response.data || { orders: [] };
    } catch (error) {
        console.error("Error fetching order delivery status:", error);
        throw error;
    }
};

const GetExistingOpenOrders = async (data: any) => {
    try {
        const existingOpenorders: any = await api
            .post(ApiConstant.GetExistingOpenOrders, data)
            .then((result: any) => {
                if (result)
                    return result.data;
                else
                    return null;
            })
            .catch(function (error: any) {
                console.error('error Getting Existing Openorders', error);
            });
        const response = existingOpenorders != null ? existingOpenorders : null;
        return response;
    }
    catch {
        console.log('error Getting Existing Openorders');
        return false;
    }
}

  const SaveDeliveryInstruction = async (orderId: number, instruction: string) => {
    try {
        const payload = {
            orderId: orderId,
            instruction: instruction
        };

        const response: any = await api
            .post(ApiConstant.SaveDeliveryInstruction, payload)
            .then((result: any) => {
                if (result)
                    return result.data;
                else
                    return null;
            })
            .catch(function (error: any) {
                console.error('Error adding order instruction', error);
            });

        const finalResponse = response != null ? response : null;
        return finalResponse;
    } catch {
        console.log('Error adding order instruction');
        return false;
    }
};

const getOrderInstructions = async (orderId: number) => {
  try {
    const payload = { orderId };
    const response: any = await api
      .post(ApiConstant.GetOrderInstructionsAndComments, payload)
      .then((result: any) => (result ? result.data : null))
      .catch((error: any) => {
        console.error("Error fetching order instructions/comments", error);
      });
    return response ?? null;
  } catch {
    console.log("Error fetching order instructions/comments");
    return false;
  }
};

const GetChallanDetails = async (data: any) => {
    try {
        const challanDetails: any = await api
            .post(ApiConstant.getChallanDetails, data)
            .then((result: any) => {
                if (result)
                    return result.data;
                else
                    return null;
            })
            .catch(function (error: any) {
                console.error('Error fetching Challan details', error);
            });
        const response = challanDetails != null ? challanDetails : null;
        return response;
    } 
    catch {
        console.log('Error fetching Challan details');
        return false;
    }
};

const GetChallanDetailsByNo = async (challanNo: number) => {
    try {
        const challanDetail: any = await api
            .get(`${ApiConstant.getChallanDetailByNo}${challanNo}`)
            .then((result: any) => {
                if (result)
                    return result.data;
                else
                    return null;
            })
            .catch(function (error: any) {
                console.error('Error fetching Challan detail by number', error);
            });
        const response = challanDetail != null ? challanDetail : null;
        return response;
    }
    catch {
        console.log('Error fetching Challan detail by number');
        return false;
    }
};

const FetchEwayBill = async (ewayBillNo: string, challanNo: number) => {
  try {
    const payload = {
      EwayBillNo: ewayBillNo,
      DocNo: challanNo.toString(),
    };

    const response: any = await api
      .post(ApiConstant.fetchEwayBill, payload)
      .then((result: any) => {
        if (result && result.data) return result.data;
        else return null;
      })
      .catch(function (error: any) {
        console.error("Error fetching Eway Bill", error);
      });

    const result = response != null ? response : null;
    return result;
  } catch (error) {
    console.error("Error in FetchEwayBill service", error);
    return false;
  }
};

const updateDelayedStatus = async (orderIds: number[]) => {
    try {
        const payload = {
            orderIDs: orderIds,
        };

        const response: any = await api
            .post(ApiConstant.UpdateDelayedStatus, payload)
            .then((result: any) => {
                if (result)
                    return result.data;
                else
                    return null;
            })
            .catch(function (error: any) {
                console.error('Error updating delayed status', error);
                return null;
            });

        const finalResponse = response != null ? response : null;
        return finalResponse;
    } catch (error) {
        console.error('Error updating delayed status', error);
        return false;
    }
};

const getVesselDetailsByChallan = async (challanNo: number) => {
  try {
    const response = await api.get(`${ApiConstant.getVesselDetailsByChallan}?challanNo=${challanNo}`
    );
    return response?.data || [];
  } catch (error) {
    console.error("Error fetching vessel details by challan:", error);
    return [];
  }
};

const addOrderComment = async (orderId: number, commentText: string) => {
    try {
        const payload = {
            orderId: orderId,
            comment: commentText
        };

        const response: any = await api
            .post(ApiConstant.addOrderComment, payload)
            .then((result: any) => {
                if (result)
                    return result.data;
                else
                    return null;
            })
            .catch(function (error: any) {
                console.error('Error adding order instruction', error);
            });

        const finalResponse = response != null ? response : null;
        return finalResponse;
    } catch {
        console.log('Error adding order instruction');
        return false;
    }
};

 const SaveCustomerInstruction = async (customerUserId: number, instruction: string) => {
    try {
        const payload = {
            customerUserId: customerUserId,
            instruction: instruction
        };

        const response: any = await api
            .post(ApiConstant.SaveCustomerInstruction, payload)
            .then((result: any) => {
                if (result)
                    return result.data;
                else
                    return null;
            })
            .catch(function (error: any) {
                console.error('Error adding order instruction', error);
            });

        const finalResponse = response != null ? response : null;
        return finalResponse;
    } catch {
        console.log('Error adding order instruction');
        return false;
    }
};

const getCustomerInstruction = async (customerUserId: number) => {
  try {
    const payload = { customerId: customerUserId };

    const response: any  = await api
      .post(ApiConstant.GetCustomerInstruction, payload)
      .then((result: any) => (result ? result.data : null))
      .catch((error: any) => {
        console.error("Error fetching customer instruction", error);
      });

    return response ?? null;
  } catch {
    console.log("Error fetching customer instruction");
    return false;
  }
};

const orderServices = {
    getOrders,
    getOrderUsers,
    getPOS,
    GetPackingOrderByOrderId,
    saveOrderPacking,
    getOrderCities,
    binOrderDetails,
    orderOrderdDetails,
    getorderExport,
    getOrderExportDetails,
    getInvoices,
    getInvoicedetails,
    getuserdetails,
    getUserDetailComplaint,
    GetOrderByOrderId,
    orderInvoicedDetails,
    getOrderInvoiceExportdetails,
    importDriverList,
    sendWhatsAppTemplateMessage,
    getDeliveredOrders,
    getDeliveryOrders,
    getCashCollectionReport,
    getAdminDeliveryDetails,
    getAdminDeliveredDetails,
    getPaymentLinkList,
    updateActualpayment,
    cashandOnlineList,
    getDriversList,
    getOrderAddress,
    getChallanProducts,
    createChallan,
    GenerateInvoiceDetails,
    GetOrderByOrderIdForInvoice,
    GetPullPaymentStatusLogs,
    getOpenOrdersForMap,
    orderoptimized,
    getCustomerDeliveryReport,
    getVesselDetails,
    getPaymentOrderStatus,
    searchDelayStatus,
    saveDeliveryDelay,
    getDelayedOrders,
    getAdminDelayedDetails,
    getDriversDetails,
    getDeliveryAnalysis,
    getAssignedOrdersDetails,
    getUndeliveredOrdersDetails,
    getDeliveredOrdersDetails,
    getPreChallanProducts,
    getAssignedCancelledOrdersDetails,
    importDriverList1,
    getDriverOrdersDailySummary,
    GetExistingOpenOrders,
    getOrderDeliveryStatus,
    searchSupplyType,
    searchSubSupplyType,
    searchDocumentType,
    searchTransportationMode,
    searchConsignmentStatus,
    searchModeOfGeneration,
    searchEwayBillStatus,
    searchCancellationReasonCodes,
    searchVehicleType,
    searchReasonForExtensionValidity,
    searchTransactionTypes,
    generateEwayBill,
    SaveDeliveryInstruction,
    getOrderInstructions,
    GetChallanDetails,
    GetChallanDetailsByNo,
    FetchEwayBill,
    updateDelayedStatus,
    getVesselDetailsByChallan,
    addOrderComment,
    SaveCustomerInstruction,
    getCustomerInstruction
};

export default orderServices;

